import { IntlShape } from 'react-intl';
import { RIGHT_ALIGNED, RIGHT_ALIGNED_STYLES } from 'common/constants';
import { tooltipGenerator } from 'components/ComposedTable/utils';
import { RemittanceFormRenderer } from 'components/RemittanceFormRenderer';
import { formatCurrency } from 'utils/formatCurrency';
import { labelMessages } from './messages';
import { VendorPaymentDetails } from './types';
import type { ITooltipParams, ColDef } from 'ag-grid-community';

export const completedPaymentTableColumns = (intl: IntlShape): ColDef[] => [
  {
    field: 'vendorNo',
    headerName: intl.formatMessage(labelMessages.vendorNoLabel),
    minWidth: 150
  },
  {
    field: 'vendorName',
    headerName: intl.formatMessage(labelMessages.vendorNameLabel),
    minWidth: 50,
    width: 300
  },
  {
    field: 'documentId',
    headerName: intl.formatMessage(labelMessages.documentIdLabel),
    minWidth: 50,
    cellRenderer: RemittanceFormRenderer
  },
  {
    field: 'transactionId',
    headerName: intl.formatMessage(labelMessages.transactionIdLabel),
    minWidth: 50
  },
  {
    field: 'amount',
    headerName: intl.formatMessage(labelMessages.amountLabel),
    minWidth: 50,
    width: 300,
    type: RIGHT_ALIGNED,
    cellStyle: RIGHT_ALIGNED_STYLES,
    cellRenderer: ({ data }: { data: VendorPaymentDetails }) =>
      formatCurrency(data?.amount, 'decimal')
  }
];

export const failedPaymentTableColumns = (intl: IntlShape): ColDef[] => [
  {
    checkboxSelection: true,
    field: 'check',
    filter: false,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    headerName: '',
    maxWidth: 55,
    minWidth: 55,
    resizable: false,
    cellClass: 'chk-failed-record'
  },
  {
    field: 'vendorNo',
    headerName: intl.formatMessage(labelMessages.vendorNoLabel),
    minWidth: 50,
    width: 150
  },
  {
    field: 'vendorName',
    headerName: intl.formatMessage(labelMessages.vendorNameLabel),
    minWidth: 50,
    width: 300
  },
  {
    field: 'failReason',
    headerName: intl.formatMessage(labelMessages.failReasonLabel),
    minWidth: 150,
    width: 700,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tooltipValueGetter: (params: ITooltipParams): any =>
      tooltipGenerator(params)
  },
  {
    field: 'amount',
    headerName: intl.formatMessage(labelMessages.amountLabel),
    minWidth: 50,
    width: 200,
    type: RIGHT_ALIGNED,
    cellStyle: RIGHT_ALIGNED_STYLES,
    cellRenderer: ({ data }: { data: VendorPaymentDetails }) =>
      formatCurrency(data?.amount, 'decimal')
  }
];
